'use strict';

var addressConstants = require('./constants');

/**
 * Interactive blur/input field validation.
 * Handles all three cases: empty required, pattern-fail, valid.
 *
 * @param {jQuery} $field - The field element
 * @param {RegExp} regex - The pattern regex to test against
 * @param {boolean} required - Whether the field is required (default true)
 */
function validateFieldInteractive($field, regex, required) {
    if (required === undefined){
        required = true;
    }
    var value = $field.val();
    var $feedback = $field.siblings('.invalid-feedback');
    var isEmpty = !value || String(value).trim() === '';

    if (isEmpty) {
        if (required) {
            $field.addClass('is-invalid').parent().addClass('is-invalid');
            if ($feedback.length && !$feedback.text().trim()) {
                $feedback.text($field.data('missing-error') || 'Este campo es obligatorio');
            }
        } else {
            $field.removeClass('is-invalid').parent().removeClass('is-invalid');
            if ($feedback.length) {
                $feedback.text('');
            }
        }
    } else if (!regex.test(value)) {
        $field.addClass('is-invalid').parent().addClass('is-invalid');
        if ($feedback.length) {
            $feedback.text($field.data('pattern-mismatch') || 'Formato inválido');
        }
    } else {
        $field.removeClass('is-invalid').parent().removeClass('is-invalid');
        if ($feedback.length) {
            $feedback.text('');
        }
    }
}

/**
 * Validates all pattern-matching fields against their regexes.
 * Uses the provided selector map to locate each field in the form.
 *
 * @param {jQuery} $form - The form element
 * @param {Object} fieldSelectors - Map of field names to CSS selectors
 */
function validatePatternFields($form, fieldSelectors) {
    Object.keys(addressConstants.FIELD_REGEXES).forEach(function (fieldName) {
        if (fieldName === 'externalNumber') return;
        var selector = fieldSelectors[fieldName];
        if (!selector) return;
        var $field = $form.find(selector);
        if (!$field.length) return;
        validateFieldInteractive($field, addressConstants.FIELD_REGEXES[fieldName], fieldName !== 'interiorNumber');
    });
}

/**
 * Validates the external number field.
 * Marks field invalid and shows feedback if pattern fails.
 *
 * @param {jQuery} $form - The form element containing the field
 */
function validateExternalNumber($form) {
    var $externalNumber = $form.find('#externalNumber');
    var value = $externalNumber.val();
    var $feedback = $externalNumber.siblings('.invalid-feedback');

    if (value && !addressConstants.FIELD_REGEXES.externalNumber.test(value)) {
        $externalNumber.addClass('is-invalid').parent().addClass('is-invalid');
        if ($feedback.length) {
            $feedback.text($externalNumber.data('pattern-mismatch') || 'Solo letras, números y . , - /');
        }
    } else if (!value) {
        $externalNumber.addClass('is-invalid').parent().addClass('is-invalid');
        if ($feedback.length && !$feedback.text().trim()) {
            $feedback.text($externalNumber.data('missing-error') || 'Este campo es obligatorio');
        }
    } else {
        $externalNumber.removeClass('is-invalid').parent().removeClass('is-invalid');
    }
}

/**
 * Highlights required fields without values.
 * Adds invalid classes and feedback, then validates external number.
 *
 * @param {jQuery} $form - The form element to check
 */
function highlightInvalidFields($form) {
    addressConstants.REQUIRED_FIELDS.forEach(function (selector) {
        var $field = $form.find(selector);
        if (!$field.val() || $field.val().trim() === '') {
            $field.addClass('is-invalid');
            var $feedback = $field.siblings('.invalid-feedback');
            if ($feedback.length && !$feedback.text().trim()) {
                $feedback.text($field.data('missing-error') || 'Este campo es obligatorio');
            }

            if ($field.is('select')) {
                $field.parent().addClass('is-invalid');
            }
        }
    });

    validatePatternFields($form, addressConstants.ACCOUNT_FIELD_SELECTORS);
    validateExternalNumber($form);
}

/**
 * Highlights empty required fields in the checkout shipping form.
 * Uses name-based selectors to match the checkout form field naming convention.
 * @param {jQuery} $form - The shipping form element
 */
function highlightCheckoutShippingFields($form) {
    Object.keys(addressConstants.CHECKOUT_FIELD_SELECTORS).forEach(function (fieldName) {
        if (fieldName === 'interiorNumber') return;
        var selector = addressConstants.CHECKOUT_FIELD_SELECTORS[fieldName];
        var $field = $form.find(selector);
        if (!$field.val() || $field.val().trim() === '') {
            $field.addClass('is-invalid');
            var $feedback = $field.siblings('.invalid-feedback');
            if ($feedback.length && !$feedback.text().trim()) {
                $feedback.text($field.data('missing-error') || 'Este campo es obligatorio');
            }

            if ($field.is('select')) {
                $field.parent().addClass('is-invalid');
            }
        }
    });

    validatePatternFields($form, addressConstants.CHECKOUT_FIELD_SELECTORS);
    var $extNum = $form.find(addressConstants.CHECKOUT_FIELD_SELECTORS.externalNumber);
    var extValue = $extNum.val();
    var $extFeedback = $extNum.siblings('.invalid-feedback');
    if (extValue && !addressConstants.FIELD_REGEXES.externalNumber.test(extValue)) {
        $extNum.addClass('is-invalid').parent().addClass('is-invalid');
        if ($extFeedback.length) {
            $extFeedback.text($extNum.data('pattern-mismatch') || 'Solo letras, números y . , - /');
        }
    }
}

module.exports = {
    highlightInvalidFields: highlightInvalidFields,
    validateExternalNumber: validateExternalNumber,
    highlightCheckoutShippingFields: highlightCheckoutShippingFields,
    validatePatternFields: validatePatternFields,
    validateFieldInteractive: validateFieldInteractive
};
